import { Component, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { TechnicianData } from '../../../domains/common.domain';
import { SectionIdentifier } from '../review-section/review-section.domain';
import { hideButtonsForChimneySweeper } from '../review-section/review-section.component';

@Component({
  selector: 'app-technician-info',
  styleUrls: ['./technician-info.component.scss'],
  templateUrl: './technician-info.component.html',
})
export class TechnicianInfoComponent implements OnChanges {
  @Input() applicationId: number;
  @Input() isDetailsView: boolean;
  @Input() isReadOnly: boolean;
  @Input() private technicianData: TechnicianData = null;
  technicianInfoFG: FormGroup;
  TechnicianSectionIdentifier = SectionIdentifier.PersonalData_Technician;
  hideButtonsForChimneySweeper = hideButtonsForChimneySweeper;

  ngOnChanges(): void {
    if (this.technicianData?.technician_id && this.technicianData?.role !== 'customer') {
      this.prepareForm();
    }
  }

  private prepareForm(): void {
    const companyData = (this.technicianData && this.technicianData.company && this.technicianData.company[0]) || null;
    this.technicianInfoFG = new FormGroup({
      technicianId: new FormControl(this.technicianData?.technician_id),
      firstName: new FormControl(this.technicianData?.first_name),
      lastName: new FormControl(this.technicianData?.last_name),
      companyName: new FormControl(companyData?.company_name),
      telephone: new FormControl(this.technicianData?.telephone),
      email: new FormControl(this.technicianData?.email),
    });
  }
}
